import { ref } from 'vue'
import { defineStore } from 'pinia'
import { generalStore } from './index.js';
import { shoppingCart } from './shoppingCart.js';
import axios from '@/plugins/axios.js';

export const orderStore = defineStore('order', () => {
    const store = generalStore();
    const storeS = shoppingCart();

    /**
     * 
     * @param {*} data 
     */
    const setOrder = async (data) => {
        await axios.post('/orders.php', data, {
        }).then(response => {
            var id = ref(response.data);
            if (data['type'] == 'local') {
                var dataSMS = {
                    "orderNum": id.value,
                    "type": data['type'],
                    "name": data['name'],
                    "lastname": data['lastname'],
                    "phone": data['phone']
                }
            } else {
                var dataSMS = {
                    "orderNum": id.value,
                    "type": data['type'],
                    "name": data['name'],
                    "lastname": data['lastname'],
                    "phone": data['phone'],
                    "department": data['department'],
                    "city": data['city'],
                    "address": data['address']
                }
            }
            successOrder();
            setTimeout(() => { store.structSMS(dataSMS) }, 4000);
        })
            .catch(function (error) {
                console.log(error);
            });
    }

    /**
   * Function used redest shopping cart
   */
    const successOrder = () => {
        storeS.deleteShoppingCart();
        storeS.handlerSuccessShoppingCart();
    }

    return {
        setOrder
    }
})